export const Editor_Reset_Caret = 'editor_reset_caret';

export type EditorValueType = BlockValueType[];
export type BlockValueType = Array<TextValueType | InlineValueType>;
export interface TextValueType {
  text: string;
  marks?: MarkValueType[];
}
export interface InlineValueType {
  type: 'image' | 'tag';
  data?: any;
}
export interface MarkValueType {
  type: 'sz' | 'bold' | 'color' | 'highlight';
  data?: { value: string | number; szUnit?: 'pt' | 'px' };
}
